import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import DEFINE, { PATHS } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import {
    PageListComponent, HeaderListComponent,
} from "../../common/component/Index";
import Ripple from '../../common/component/Ripple';
import SupplierList from './SupplierList';
import ProductList from './ProductList';
import { get, omit } from 'lodash';
import { Tabs, PageHeader } from 'antd'
import './Supplier.less';

const { TabPane } = Tabs;
let permissionActions = [];

export default class Suppliers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            activeTab: "SUPPLIER",
            fetchSupplierLst: false
        };
    }

    componentDidMount() {
        const { location } = this.props;
        if (location) {
            if(location.state && location.state.isTab){
                this.setState({activeTab: location.state.isTab, fetchSupplierLst: true})
            }else{
                this.setState({activeTab: "SUPPLIER"})
            }
        }
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.SUPPLIER);
        this.getSuppliers();
    }

    

    render() {
        const { t, supplierState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, suppliers } = supplierState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
        const { activeTab, fetchSupplierLst } = this.state;
        
        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'suppliers'}
                        titleHeader={t('navigation.suppliers')}
                        componentRight={
                            <Fragment>{
                                permissionActions && permissionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={activeTab === 'PRODUCT' ? PATHS.SUPPLIER_PRODUCT.CREATE.path : PATHS.SUPPLIER.CREATE.path}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <div className="title-content">Danh sách nhà cung cấp và sản phẩm</div>
                    <Tabs defaultActiveKey={ activeTab } onChange={ this.onChangeTab } activeKey={ activeTab } animated={ false }>
                        {
                            permissionActions.allowView &&
                            <TabPane tab={ t('item.supplier.title') } key="SUPPLIER">
                                <SupplierList
                                    loading={isFetching}
                                    permissions={permissionActions}
                                    suppliers={suppliers}
                                    pagination={pagination}
                                    onChange={this.onTableChange}
                                    onDeleteSupplier={this.onDeleteSupplier}
                                />
                            </TabPane>
                        }
                        {
                            permissionActions.allowView &&
                            <TabPane tab={ t('item.supplier.product.title') } key="PRODUCT">
                                <ProductList
                                    getSupplierProducts={ this.props.getSupplierProducts }
                                    deleteSupplierProduct={ this.onDeleteSupplierProduct }
                                    supplierState={ this.props.supplierState }
                                    getSupplierAll={ this.props.getSupplierAll }
                                    fetchSupplierLst={ fetchSupplierLst }
                                    permissionActions={permissionActions}
                                />
                            </TabPane>
                        }
                    </Tabs>
                    
                </PageListComponent>
            </Fragment>
        );
    }

    onChangeTab = (keyActive) => {
        this.setState({ activeTab: keyActive });
        if (keyActive === 'SUPPLIER') {
            this.props.history.push({ pathname: PATHS.SUPPLIER.LIST.path, state: {isTab: "SUPPLIER"} });
            this.setState({
                fetchSupplierLst: false
            });
            this.getSuppliers();
        } else if (keyActive === 'PRODUCT') {
            this.props.history.push({ pathname: PATHS.SUPPLIER.LIST.path, state: {isTab: "PRODUCT"} });
            this.setState({ fetchSupplierLst: true });
        }
    }

    onTableChange = (pagination, filters, sorter) => {
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getSuppliers(newFilters);
    };

    getSuppliers(filters) {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSuppliers(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { supplierState } = this.props;
        const filters = omit(supplierState, [
            'suppliers', 'supplierAll', 'supplierProducts', 'detailProduct', 'detail', 
            'isFetching', 'isFetchingDetail', 'isFetchingTranslate', 'isFetchingProduct', 
            'supplierSelectData', 'totalCount', 'totalPage',
        ]);
        return removeFields ? omit(filters, removeFields) : filters;
    }

    onDeleteSupplier = (supplier) => {
        this.props.deleteSupplier(supplier, this.state.filters)
    }

    onDeleteSupplierProduct = (supplierProduct) => {
        this.props.deleteSupplierProduct(supplierProduct, this.state.filters)
    }

}

Suppliers.defaultProps = {

}
